var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmacistCaptionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2367_86484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2248 71.0002H25.702C19.1996 71.0002 13.9102 65.7104 13.9102 59.2087V35.9619C13.9102 29.4602 19.1996 24.1704 25.702 24.1704H54.2247C60.727 24.1704 66.0166 29.4602 66.0166 35.9619V44.6172H60.0803V35.9619C60.0803 32.7333 57.4537 30.1066 54.2247 30.1066H25.702C22.473 30.1066 19.8463 32.7333 19.8463 35.9619V59.2087C19.8463 62.4373 22.473 65.0641 25.702 65.0641H54.2247C57.4537 65.0641 60.0803 62.4374 60.0803 59.2087V50.5534H66.0166V59.2087C66.0166 65.7104 60.7271 71.0002 54.2248 71.0002Z",
    fill: "#F2F3EE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9044 56.4892H31.3616C26.4588 56.4892 22.4844 52.5148 22.4844 47.612V47.5585C22.4844 42.6554 26.4591 38.6807 31.3622 38.6807H47.905C52.8078 38.6807 56.7823 42.6551 56.7823 47.5579V47.6113C56.7823 52.5145 52.8076 56.4892 47.9044 56.4892ZM28.4205 47.5205V47.6494C28.4205 49.253 29.7206 50.5531 31.3242 50.5531H47.9424C49.546 50.5531 50.8461 49.2531 50.8461 47.6494V47.5205C50.8461 45.9169 49.5461 44.6168 47.9424 44.6168H31.3242C29.7206 44.6169 28.4205 45.9169 28.4205 47.5205Z",
    fill: "#F2F3EE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.9322 38.6807H36.9961V56.4892H42.9322V38.6807Z",
    fill: "#F2F3EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4642 22.8511H23.8047V9H55.4642V22.8511ZM29.7408 16.9149H49.5281V14.9362H29.7408V16.9149Z",
    fill: "#F2F3EE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8671 30.1065H31.0586V16.915H48.8671V30.1065ZM36.9947 24.1703H42.9309V22.8512H36.9947V24.1703Z",
    fill: "#F2F3EE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2367_86484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.1064,
    height: 62,
    fill: "white",
    transform: "translate(13.9102 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacistCaptionWhite);
export default __webpack_public_path__ + "static/media/pharmacist-caption-white.385178edab1262f9fd9d193a35184f76.svg";
export { ForwardRef as ReactComponent };